(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["Graphs"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["Graphs"] = factory(root["React"], root["ReactDOM"], root["_"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5442__, __WEBPACK_EXTERNAL_MODULE__6003__, __WEBPACK_EXTERNAL_MODULE__9276__) => {
return 